import * as Yup from 'yup';

const taxIdValidationSchema = (selectedTaxId) => {
  if (selectedTaxId) {
    return Yup.string()
      .required()
      .matches(new RegExp(selectedTaxId.regularExpression))
      .nullable();
  } else {
    return Yup.string()
      .required()
      .nullable();
  }
};

export const buildEssentialAccountOrganizationDetailsStepFormInitialValues = (values) => {
  return {
    company: values.company,
    organisationSize: values.organisationSize,
    client_terms_of_use_agreement: values.client_terms_of_use_agreement,
  };
};

export const buildEssentialAccountOrganizationDetailsStepFormValidationSchema = (selectedTaxId) => {
  return Yup.object().shape({
    client_terms_of_use_agreement: Yup.boolean()
      .required()
      .oneOf([true])
      .default(false),
    organisationSize: Yup.number().required(),
    company: Yup.object()
      .shape({
        displayName: Yup.string()
          .min(2)
          .max(50)
          .required(),
        legalName: Yup.string()
          .min(2)
          .max(50)
          .required(),
        addressLine1: Yup.string().required(),
        addressLine2: Yup.string(),
        city: Yup.string()
          .min(2)
          .max(50)
          .required(),
        country: Yup.string()
          .min(2)
          .max(50)
          .required(),
        postalCode: Yup.string()
          .min(2)
          .max(50)
          .required(),
        registrationNumber: Yup.string().required(),
        taxIdType: Yup.string().required(),
        taxId: taxIdValidationSchema(selectedTaxId),
        state: Yup.string().nullable(),
        dpoEmail: Yup.string().nullable(),
        creditNotificationThreshold: Yup.number().required(),
      })
      .required(),
  });
};

export const buildAcceptEssentialAccountInvitationFormInitialValues = (fullName, email) => {
  const ownerFirstAndLastName = fullName.split(' ');
  const ownerFirstName = ownerFirstAndLastName.length > 0 ? ownerFirstAndLastName[0] : ownerFirstAndLastName;
  const ownerLastName = ownerFirstAndLastName.length > 0 ? ownerFirstAndLastName[1] : ownerFirstAndLastName;

  return {
    owner: {
      firstName: ownerFirstName,
      lastName: ownerLastName,
      email,
      password: '',
      confirmPassword: '',
      locale: '',
      country: '',
      timeZone: '',
    },
    organisationSize: 0,
    company: {
      displayName: '',
      legalName: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      country: '',
      postalCode: '',
      registrationNumber: '',
      taxIdType: '',
      taxId: '',
      state: '',
      dpoEmail: '',
      creditNotificationThreshold: 1,
    },
    inviteSenderAsExternalSupport: false,
    user_terms_of_use_agreement: false,
    client_terms_of_use_agreement: false,
    gp_invoice_address_confirmation: false,
    additionalUsers: [],
  };
};

export const buildAcceptEssentialAccountInvitationFormValidationSchema = () => {
  return Yup.object().shape({});
};

export const extractInput = (values, userExists, token) => {
  const { owner } = values;

  if (userExists) {
    return {
      token,
      owner: null,
      organisationSize: values.organisationSize,
      company: {
        ...values.company,
      },
      additionalUsers: values.additionalUsers,
      inviteSenderAsExternalSupport: values.inviteSenderAsExternalSupport,
    };
  }

  return {
    token,
    owner: {
      userInvitationToken: token,
      firstName: owner.firstName,
      lastName: owner.lastName,
      email: owner.email,
      password: owner.password,
      locale: owner.locale,
      country: owner.country,
      timeZone: owner.timeZone,
    },
    organisationSize: values.organisationSize,
    company: {
      ...values.company,
    },
    additionalUsers: values.additionalUsers,
    inviteSenderAsExternalSupport: values.inviteSenderAsExternalSupport,
  };
};
